import React from 'react';
import {
  DashboardOutlined,
  FileTextOutlined,
  ShoppingOutlined,
  InboxOutlined,
  DatabaseOutlined,
  AppstoreOutlined,
  SettingOutlined,
  CheckCircleOutlined,
  BranchesOutlined,
  SafetyCertificateOutlined,
  BarChartOutlined,
  HistoryOutlined,
  HomeOutlined,
  AccountBookOutlined,
} from '@ant-design/icons';
import { RoleName, hasRole } from './auth';
import { getConsolidatedNavigation } from './modules/registry';

export interface NavItemConfig {
  key: string;
  label: string;
  path: string;
  icon?: React.ReactNode;
  allowedRoles?: RoleName[];
  children?: NavItemConfig[];
}

export const NAVIGATION_ITEMS: NavItemConfig[] = getConsolidatedNavigation();

/**
 * Filter navigation items based on user roles
 */
export function getAuthorizedNavItems(
  items: NavItemConfig[],
  userRoles: RoleName[]
): NavItemConfig[] {
  // Use live consolidated items from module registry
  const liveItems = items && items.length > 0 ? items : getConsolidatedNavigation();

  return liveItems
    .filter((item) => {
      if (!item.allowedRoles || item.allowedRoles.length === 0) {
        return true;
      }
      return hasRole(userRoles, item.allowedRoles);
    })
    .map((item) => {
      if (!item.children) {
        return item;
      }
      const authorizedChildren = getAuthorizedNavItems(item.children, userRoles);
      return {
        ...item,
        children: authorizedChildren.length > 0 ? authorizedChildren : undefined,
      };
    })
    .filter((item) => {
      // If item had children originally but none remain authorized, exclude it
      if (liveItems.find((i) => i.key === item.key)?.children && !item.children) {
        return false;
      }
      return true;
    });
}
